import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  .ant-select {
    background-color: transparent;

    .ant-select-selector {
      background-color: transparent !important;
    }
  }

  .ant-picker {
    min-width: 240px;
    background-color: transparent;
  }
`;
